export type roleType =
  | 'admin'
  | 'adminMES'
  | 'adminMH'
  | 'adminME'
  | 'bishkekFin'
  | 'employeeMES'
  | 'employeeMH'
  | 'employeeME'
  | 'employeeBishkek'
  | 'accelerator'
  | 'teacher'
  | 'commission'
  | 'chairman'
  | 'secretary'
  | 'parent'
  | 'aymakFin'
  | 'monFin'
  | 'monAccountant'
  | 'member'
  | 'goronoRepublicanOfSignification'
  | 'goronoRegionOfSignification'
  | 'goronoDistrictOfSignification'
  | 'directorPreschool';

export enum RoleType {
  adminMe = 'adminME',
  goronoRepublicanOfSignification = 'goronoRepublicanOfSignification',
  goronoRegionOfSignification = 'goronoRegionOfSignification',
  goronoDistrictOfSignification = 'goronoDistrictOfSignification',
}

export interface User {
  type: number;
  s: string;
  n: string;
  p: string | null;
  org: number;
  role: roleType[];
  exp: number;
}
